import * as yup from 'yup';
import { FormType } from './Employment.types';
import { FIELDS } from 'modules/cm/fields/types';
import { nullableNumber, nullableString } from 'utils/form/validation';

export default yup.object().shape<FormType>({
  [FIELDS.APPLICANT_EMPLOYMENT_STATUS]: nullableString(),
  [FIELDS.APPLICANT_EMPLOYED_JOB_TITLE]: nullableString(),
  [FIELDS.APPLICANT_EMPLOYED_COMPANY_NAME]: nullableString(),
  [FIELDS.APPLICANT_EMPLOYED_COMPANY_ADDRESS]: nullableString(),
  [FIELDS.APPLICANT_EMPLOYED_NATURE]: nullableString(),
  [FIELDS.APPLICANT_EMPLOYED_START_DATE]: nullableString(),
  [FIELDS.APPLICANT_EMPLOYED_ANTICIPATED_AGE]: nullableNumber(),
  [FIELDS.APPLICANT_SELF_EMPLOYED_JOB_TITLE]: nullableString(),
  [FIELDS.APPLICANT_SELF_EMPLOYED_COMPANY_NAME]: nullableString(),
  [FIELDS.APPLICANT_SELF_EMPLOYED_COMPANY_ADDRESS]: nullableString(),
  [FIELDS.APPLICANT_SELF_EMPLOYED_NATURE]: nullableString(),
  [FIELDS.APPLICANT_SELF_EMPLOYED_START_DATE]: nullableString(),
  [FIELDS.APPLICANT_BUSINESS_TYPE]: nullableString(),
  [FIELDS.APPLICANT_SELF_EMPLOYED_ANTICIPATED_AGE]: nullableNumber(),
});
